// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalTemplate_eONzR {
  height: 80vh;
  width: 70%;
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--f6-background);
  transform: translate(-50%, -50%);
  z-index: 5;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  overflow-x: hidden;
  overflow-y: auto;

  animation: scaleUp_gZZw1 300ms ease-out forwards;
  -webkit-animation: scaleUp_gZZw1 300ms ease-out forwards;
  height: 100vh;
  width: 100vw;
  max-width: 100vw;
  box-sizing: border-box;

  @media (width<768px) {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
    box-sizing: border-box;
  }

  p,
  h3 {
    margin: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.bg_KIion {
  background-color: var(--_00000020-background);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.modalTemplateHeader_wTzjx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 10px;
  position: sticky;
  top: 0px;
  z-index: 1;
  background: var(--f6-background);
}

.modalTemplateInfo_K7K87 {
  display: flex;
  align-items: center;
  gap: 30px;

  h3 {
    text-transform: capitalize;
    color: var(--black-color);

    @media (width<=768px) {
      font-size: 15px;
    }

    @media (width<=450px) {
      display: none;
    }
  }

  .iconContainer_l37TM {
    background-color: var(--_10a37f-background);
    padding: 6px;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;

    .icon_f1LRx {
      height: 18px;
      width: 18px;
    }
  }
}

.buttonContainer_xbUrl {
  display: flex;
  gap: 10px;
}

.profileImageCenter_Z69oF {
  flex-direction: column-reverse;
  align-items: center;
}

.contentContainer_uS4j7 {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  width: 100%;
  margin: 0 auto;
  gap: 10px;
  height: calc(100vh - 50px);

  overflow: scroll;
}

.reverseMobile_hZVs5 {
  @media (width<=768px) {
    flex-direction: column-reverse;
    width: 100%;
    padding: 0;
  }
}

.scaleDown_D7dtw {
  animation: scaleDown_D7dtw 300ms ease-in forwards;
  -webkit-animation: scaleDown_D7dtw 300ms ease-in forwards;
}

@keyframes scaleUp_gZZw1 {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_D7dtw {
  from {
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_VS4Wu {
  opacity: 0;
}

.deleteContact_YouLk {
  width: 60%;
  box-sizing: border-box;
  padding: 0px 30px;
  display: flex;
  align-items: center;
  justify-content: end;
  color: var(--dc3545-background);
  gap: 7px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.9px;
  cursor: pointer;
  margin-top: 20px;
  margin: 20px auto;

  .icon_f1LRx {
    display: flex;
    padding: 5px;
    align-items: center;
    gap: 10px;
    border-radius: 200px;
    background: var(--ed-background);
  }
}

.dotsContainer_JM1R4{
  position: relative;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ModalTemplate/ModalTemplate.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,QAAQ;EACR,SAAS;EACT,sCAAsC;EACtC,gCAAgC;EAChC,UAAU;EACV,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;;EAEhB,gDAA0C;EAC1C,wDAAkD;EAClD,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;;EAEtB;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,0BAA0B;IAC1B,yBAAyB;;IAEzB;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;;IAErB;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,cAAc;EACd,SAAS;EACT,0BAA0B;;EAE1B,gBAAgB;AAClB;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".modalTemplate {\n  height: 80vh;\n  width: 70%;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--f6-background);\n  transform: translate(-50%, -50%);\n  z-index: 5;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  height: 100vh;\n  width: 100vw;\n  max-width: 100vw;\n  box-sizing: border-box;\n\n  @media (width<768px) {\n    height: 100vh;\n    width: 100vw;\n    max-width: 100vw;\n    box-sizing: border-box;\n  }\n\n  p,\n  h3 {\n    margin: 0;\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.bg {\n  background-color: var(--_00000020-background);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 5;\n}\n\n.modalTemplateHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 10px;\n  position: sticky;\n  top: 0px;\n  z-index: 1;\n  background: var(--f6-background);\n}\n\n.modalTemplateInfo {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n\n  h3 {\n    text-transform: capitalize;\n    color: var(--black-color);\n\n    @media (width<=768px) {\n      font-size: 15px;\n    }\n\n    @media (width<=450px) {\n      display: none;\n    }\n  }\n\n  .iconContainer {\n    background-color: var(--_10a37f-background);\n    padding: 6px;\n    cursor: pointer;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n\n    .icon {\n      height: 18px;\n      width: 18px;\n    }\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.profileImageCenter {\n  flex-direction: column-reverse;\n  align-items: center;\n}\n\n.contentContainer {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 10px;\n  width: 100%;\n  margin: 0 auto;\n  gap: 10px;\n  height: calc(100vh - 50px);\n\n  overflow: scroll;\n}\n\n.reverseMobile {\n  @media (width<=768px) {\n    flex-direction: column-reverse;\n    width: 100%;\n    padding: 0;\n  }\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n.deleteContact {\n  width: 60%;\n  box-sizing: border-box;\n  padding: 0px 30px;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  color: var(--dc3545-background);\n  gap: 7px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16.9px;\n  cursor: pointer;\n  margin-top: 20px;\n  margin: 20px auto;\n\n  .icon {\n    display: flex;\n    padding: 5px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 200px;\n    background: var(--ed-background);\n  }\n}\n\n.dotsContainer{\n  position: relative;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalTemplate": `modalTemplate_eONzR`,
	"scaleUp": `scaleUp_gZZw1`,
	"bg": `bg_KIion`,
	"modalTemplateHeader": `modalTemplateHeader_wTzjx`,
	"modalTemplateInfo": `modalTemplateInfo_K7K87`,
	"iconContainer": `iconContainer_l37TM`,
	"icon": `icon_f1LRx`,
	"buttonContainer": `buttonContainer_xbUrl`,
	"profileImageCenter": `profileImageCenter_Z69oF`,
	"contentContainer": `contentContainer_uS4j7`,
	"reverseMobile": `reverseMobile_hZVs5`,
	"scaleDown": `scaleDown_D7dtw`,
	"fadeOut": `fadeOut_VS4Wu`,
	"deleteContact": `deleteContact_YouLk`,
	"dotsContainer": `dotsContainer_JM1R4`
};
export default ___CSS_LOADER_EXPORT___;
